import { render, staticRenderFns } from "./frontend.vue?vue&type=template&id=81ab449a&scoped=true&lang=pug&"
import script from "./frontend.vue?vue&type=script&lang=js&"
export * from "./frontend.vue?vue&type=script&lang=js&"
import style0 from "./frontend.vue?vue&type=style&index=0&id=81ab449a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ab449a",
  null
  
)

export default component.exports